import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const PharmacyStatus = types.compose(
  BaseEntity,
  types.model('PharmacyStatus', {
    pharmacyStatusId: types.identifierNumber,
    code: types.maybe(types.string),
    name: types.maybe(types.string),
    orderNr: types.number,
  }),
);